import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import media from "../../styles/media";
import Container from "../ui/Container";
import { CONTACTS, FOOTER_COLUMNS } from "../../config/navigation";
import { ROUTES } from "../../config/routes";
import emblemLight from "../../assets/img/emblem-light.png";

const Wrapper = styled.footer`
  margin-top: auto;
  padding: 56px 0 40px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, 1.2fr) repeat(5, minmax(130px, 1fr));
  gap: 32px;

  ${media.xl} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${media.lg} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${media.md} {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  ${media.sm} {
    grid-template-columns: 1fr;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Logo = styled.img`
  width: 160px;
  height: auto;
`;

const BrandText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  line-height: 1.5;
`;

const Column = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ColumnTitle = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.onPrimary};
`;

const ColumnList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
`;

const ColumnLink = styled(Link)`
  color: ${({ theme }) => theme.colors.onPrimary};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  opacity: 0.9;

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

const ContactText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  opacity: 0.9;
`;

const ContactLink = styled.a`
  color: ${({ theme }) => theme.colors.onPrimary};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }
`;

/**
 * Раньше подвал был жёстко зафиксирован (`height: 317px`) и на мобильных
 * ломался: `width: 767px` резал контент. Теперь это адаптивный grid.
 */
export function SiteFooter() {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <Grid>
          <Brand>
            <Link to={ROUTES.home} aria-label={t("home")}>
              <Logo src={emblemLight} alt="" />
            </Link>
            <BrandText>{t("text1")}</BrandText>
          </Brand>

          {FOOTER_COLUMNS.map((column) => (
            <Column key={column.id} aria-labelledby={`footer-${column.id}`}>
              <ColumnTitle id={`footer-${column.id}`}>
                {t(column.titleKey)}
              </ColumnTitle>
              <ColumnList>
                {column.links.map((link) => (
                  <li key={link.labelKey}>
                    <ColumnLink to={link.to}>{t(link.labelKey)}</ColumnLink>
                  </li>
                ))}
              </ColumnList>
            </Column>
          ))}

          <Column aria-labelledby="footer-contacts">
            <ColumnTitle id="footer-contacts">{t("contacts")}</ColumnTitle>
            <ColumnList>
              <li>
                <ContactText>{t("city")}</ContactText>
              </li>
              <li>
                <ContactLink href={CONTACTS.phoneHref}>
                  {CONTACTS.phone}
                </ContactLink>
              </li>
              <li>
                <ContactText>{t("email")}</ContactText>
              </li>
            </ColumnList>
          </Column>
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default SiteFooter;
